import $ from 'jquery';
import { size } from './config';
import PerfectScrollbar from './perfect-scrollbar.min';

const scrollbars = new Map();

function initCompare() {
    //scroll
    createCustomScroll();

    $('.js-compare-scrollbar').each(function () {
        const categoryId = $(this).data('category-id');
        const $btn = $('.js-only-diff[data-category-id="' + categoryId + '"]');
        let isAllDifferent = true; // Означает, что все характеристики в товарах для сравения различаются. Тогда скроем кнопку "Показать различия"
        // Проверим есть ли у товаров из сравнения одинаковые значения характеристик
        $(this).find('.js-compare-item').each(function () {
            let value;
            let isEqual = true;
            $(this).find('.js-compare-value[data-slider="1"]').each(function () {
                if (!value) {
                    value = $(this).text();
                } else if (value !== $(this).text()) {
                    isEqual = false;
                }
            });

            if (isEqual) {
                isAllDifferent = false;
            }
        });

        if (isAllDifferent) { // Скроем кнопку "Показывать только различия", чтобы не путать покупателя
            $btn.hide();
        }
    });

    $('.js-compare-slider-left, .js-compare-slider-right').on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        changePaging(slick, nextSlide);
        changeValues(slick, nextSlide);
    });

    $('.js-compare-slider-left, .js-compare-slider-right').on('init', function (e, slick) {
        changePaging(slick, slick.currentSlide);
        changeValues(slick, slick.currentSlide);
    });

    $('.js-compare-remove').on('click', function (e) {
        e.preventDefault();

        // запрос

        $.post('/compare/delete/' + $(this).data('product-id'),
            function (data) {
                if (data['status']) {
                    location.reload(true);
                }
            }
        );


        if (window.innerWidth >= size.smDesktop) {
            const $this = $(this);
            const $slide = $this.closest('.js-compare-slide');
            const goodId = $slide.data('good');
            $(`.js-compare-value`).each(function () {
                const $this = $(this);
                if ($this.data('good') === goodId) {
                    $this.remove();
                }
            });
            $(`.js-compare-slide[data-good="${goodId}"]`).each(function () {
                const $slide = $(this);

                if (!$slide.is(':visible')) {
                    $slide.remove();
                    return
                }

                $slide.on('animationend', function () {
                    $(this).remove();
                    if ($('.js-compare-slide').length === 0) {
                        $('.js-compare-section').addClass('_empty')
                    }
                });

                $slide.addClass("_remove-animation");

            })
        } else {
            const $slider = $(this).closest('.js-compare-slider-left, .js-compare-slider-right');

            const slick = $slider.slick('getSlick');
            let index = slick.currentSlide;
            const goodId = slick.$slides[index].dataset.good;
            $(`.js-compare-value[data-good="${goodId}"]`).remove();

            $('.js-compare-slider-left, .js-compare-slider-right').each(function () {
                const slick = $(this).slick('getSlick');
                slick.removeSlide(index);

                changePaging(slick, slick.currentSlide);
                changeValues(slick, slick.currentSlide);
            });
        }

        // вынести в функцию
        if (isOnlyDiffActive) {
            // $(this).addClass('_active');
            $('.js-compare-item').each(function () {
                let value
                let isEqual = true
                $(this).find('.js-compare-value[data-slider="1"]').each(function () {
                    if (!value) {
                        value = $(this).text();
                    } else if (value !== $(this).text()) {
                        isEqual = false;
                    }
                });

                if (isEqual) {
                    $(this).addClass('_hidden');
                } else {
                    $(this).removeClass('_hidden');
                }
            });
        } else {
            $('.js-compare-item').removeClass('_hidden');
        }

        if (ps) {
            ps.update();
        }
    });

    let isOnlyDiffActive = false;
    $('.js-only-diff').on('click', function () {
        const categoryId = $(this).data('category-id');
        const $block = $('.js-compare-scrollbar[data-category-id="' + categoryId + '"]');
        isOnlyDiffActive = !isOnlyDiffActive;

        if (isOnlyDiffActive) {
            $(this).html('Показывать все параметры');
            $(this).addClass('_active');
            $block.find('.js-compare-item').each(function () {
                let value
                let isEqual = true
                $(this).find('.js-compare-value[data-slider="1"]').each(function () {
                    if (!value) {
                        value = $(this).text();
                    } else if (value !== $(this).text()) {
                        isEqual = false;
                    }
                });

                if (isEqual) {
                    $(this).addClass('_hidden');
                } else {
                    $(this).removeClass('_hidden');
                }
            });
        } else {
            $(this).html('Показывать только различия');
            $(this).removeClass('_active');
            $block.find('.js-compare-item').removeClass('_hidden');
        }
    });

    function changePaging(slick, current) {
        const count = slick.slideCount;
        slick.$slider.closest('.js-slider-container').find('.js-slider-paging').text(`${current + 1}/${count}`);
    }

    function changeValues(slick, current) {
        const goodId = slick.$slides[current].dataset.good;
        const sliderId = slick.$slider.data('slider');
        $(`.js-compare-value[data-slider="${sliderId}"]`).each(function () {
            const $this = $(this);
            if ($this.data('good') == goodId) {
                $this.addClass('_active');
            } else {
                $this.removeClass('_active');
            }
        });
    }

    function createCustomScroll() {
        const scrollContainer = $('.js-compare-scrollbar');
        if (!scrollContainer.length) return;

        fillMap(scrollContainer);

        $(window).on('resize', function () {
            if (window.innerWidth < size.smDesktop && scrollbars.size > 0) {
                scrollbars.forEach((value, key) => {
                   value.destroy();
                   scrollbars.delete(key)
                });

            } else if (window.innerWidth >= size.smDesktop && scrollbars.size < 1) {
                fillMap(scrollContainer);
            }
        });


    }

    function fillMap(scrollContainer) {
        $.each(scrollContainer, function (i, el) {
            if (window.innerWidth >= size.smDesktop) {
                scrollbars.set(el, new PerfectScrollbar(el));
            }
        })
    }
}

export {
    initCompare,
    scrollbars
};